import apiClient from '../client';

export interface CodingProblem {
  id: number;
  title: string;
  problem_statement: string;
  input_format: string;
  output_format: string;
  sample_input: string;
  sample_output: string;
  test_cases: Array<{ input: string; output: string; description?: string }>;
  time_limit: number;
  memory_limit: number;
  difficulty: string;
  category?: string;
  company_tags?: string[];
  starter_code?: Record<string, string>;
  solution_code?: Record<string, string>;
  created_at: string;
  updated_at: string;
}

export interface CodeSolution {
  id: number;
  problem_id: number;
  language: string;
  solution_code: string;
  explanation: string;
  time_complexity?: string;
  space_complexity?: string;
  approach?: string;
  created_at: string;
  updated_at: string;
}

export const codingService = {
  async listProblems(params: {
    page?: number;
    per_page?: number;
    difficulty?: string;
    category?: string;
    company?: string;
    search?: string;
  }) {
    return apiClient.get('/api/v1/coding/problems', { params });
  },
  async getProblem(id: number) {
    return apiClient.get(`/api/v1/coding/problems/${id}`);
  },
  async getSolutions(problemId: number) {
    return apiClient.get(`/api/v1/coding/problems/${problemId}/solutions`);
  },
  async getMySolutions(problemId: number) {
    return apiClient.get(`/api/v1/coding/problems/${problemId}/my-solutions`);
  },
  async executeCode(problemId: number, code: string, language: string) {
    return apiClient.post(`/api/v1/coding/problems/${problemId}/execute`, { code, language });
  },
  async submitSolution(problemId: number, data: {
    code: string;
    language: string;
    explanation?: string;
    time_complexity?: string;
    space_complexity?: string;
    approach?: string;
  }) {
    return apiClient.post(`/api/v1/coding/problems/${problemId}/submit`, data);
  },
  async getCategories() {
    return apiClient.get('/api/v1/coding/categories');
  },
  async getCompanies() {
    return apiClient.get('/api/v1/coding/companies');
  },
};